import { CSWAP, SWAPV2, SPOT, STANDARD, COMMON,COPYTRADE,AGENT } from '../modules'
import { commonConfig } from './common/index'
import { spotConfig } from './spot/index'
import { standardConfig } from './standard/index'
import { swapV2Config } from './swapV2/index'
import { cswapConfig } from './cswap/index'
import { copyTradeConfig } from './copyTrade/index'
import { agentConfig } from './agent/index'

export const navMenus = {
  [SWAPV2]: 'U本位永續合約',
  [CSWAP]: '币本位永續合約',
  [SPOT]: '現貨',
  [STANDARD]: '標準合約',
  [COMMON]: '賬戶與錢包',
  [COPYTRADE]: '跟單',
  [AGENT]: '代理',
}

export const rootConfig = {
  [SWAPV2]: swapV2Config,
  [CSWAP]: cswapConfig,
  [COMMON]: commonConfig,
  [SPOT]: spotConfig,
  [STANDARD]: standardConfig,
  [COPYTRADE]: copyTradeConfig,
  [AGENT]: agentConfig,
}


// WEBPACK FOOTER //
// ./src/config/zh-tw/index.js